import React, { useEffect, useState } from "react";
// import { Card, CardContent, Box, Button, Tabs, Tab } from "@mui/material";
import * as services from "./../../services/customer";
import * as localServices from "./../../services/local";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import PersonalInfoForm from "./personal_Info_form";
import PaymentInfoForm from "./persnal_payment_form";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as salengServices from "./../../services/saleng";

const { v4: uuidv4 } = require("uuid");

const CustomerForm = () => {
  const [searchParams] = useSearchParams();
  const sale = searchParams.get("sale") === "true";

  const [group, setGroup] = useState("");
  const [personType, setPersonType] = useState("normal");

  const [cars, setCars] = useState([]); // { type, license, province }
  const [drivers, setDrivers] = useState([]); // { name, surname, idCard }

  const [tabIndex, setTabIndex] = useState(0);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    citizenId: "",
    phone: "",
    address: "",
    img: "",
    dob: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchGroup();
  }, []);

  const fetchGroup = async () => {
    try {
      const res = await services.getGroup();
      const rawData = res.data?.data || [];
      const mapped = rawData.map((g) => ({
        id: g.id,
        name: g.name || "-",
      }));
      setCustomerGroups(mapped);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const readCard = async () => {
    try {
      const res = await localServices.readCard();
      const data = res.data.data;
      setFormData((prev) => ({
        ...prev,
        name: `${data.firstNameTH} ${data.lastNameTH}`,
        dob: data.birthday,
        citizenId: data.citizenId,
        address: data.address,
        img: data.photo,
      }));
      console.log("ข้อมูลบัตร:", res.data);
    } catch (err) {
      console.error("err:", err);
      alert("ไม่สามารถอ่านบัตรได้");
    }
  };

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleTabChange = (_, newValue) => setTabIndex(newValue);

  // ============ Cars ============
  // รองรับทั้งเรียกแบบไม่มีพารามฯ (เพิ่มเปล่า) และแบบ Dialog ส่งอ็อบเจ็กต์มา
  const handleAddCar = (car) => {
    if (car && typeof car === "object") {
      setCars((prev) => [...prev, car]);
    } else {
      setCars((prev) => [...prev, { type: "", license: "", province: "" }]);
    }
  };
  const handleDeleteCar = (index) => {
    setCars((prev) => prev.filter((_, i) => i !== index));
  };
  const handleCarChange = (index, field, value) => {
    setCars((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  // ============ Drivers ============
  const handleAddDriver = (driver) => {
    if (driver && typeof driver === "object") {
      // กัน key พิมพ์ผิด
      const normalized = {
        name: driver.name || "",
        surname: driver.surname || driver.suername || "", // เผื่อกรณีเก่าพิมพ์ตก
        idCard: driver.idCard || "",
      };
      setDrivers((prev) => [...prev, normalized]);
    } else {
      setDrivers((prev) => [...prev, { name: "", surname: "", idCard: "" }]);
    }
  };
  const handleDeleteDriver = (index) => {
    setDrivers((prev) => prev.filter((_, i) => i !== index));
  };
  const handleDriverChange = (index, field, value) => {
    setDrivers((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  const handleSubmit = async () => {
    try {
      // อัปโหลดรูปถ้าเป็น base64
      if (formData.img && isBase64(formData.img)) {
        const blob = base64ToBlob(formData.img);
        const form = new FormData();
        form.append("file", blob, "image.png");
        const response = await services.upload(form);
        formData.img = response.data.file; // ใส่ URL ไฟล์หลังอัปโหลด
      }

      const payload = {
        ...formData,
        personType,
        cars,
        drivers,
        ...(group !== "" && { customerGroupId: Number(group) }),
        // ✅ แจ้งฝั่งเซิร์ฟเวอร์ว่าเป็นลูกค้าขายของ
        customerType: "SELLER",
        // NOTE: shopId/branchId ถ้ามี context ควรยัดมาด้วยจาก store หรือ props
      };

      const res = await services.createCustomer(payload);
      const data = res.data;
      console.log('data',data);
      if (data.success) {
        toast.success("เพิ่มรายการสำเร็จ!");

        if (sale) {
          const customer = data.data;

          const payload = {
            transactionId: uuidv4(),
            customerId: customer.id,
            // carId: customer.cars?.id,
            // driverId: customer.drivers?.id,
            customerName: customer.name,
            status: "waiting",
          };
          const response = await salengServices.createSaleTransaction(payload);
          console.log('response',response);
          navigate(
            `/sale/checkout?id=${response.data.data.transactionId}&ticket=${response.data.data.billNumber}&status=${response.data.data.status}`
          );
        } else {
          // navigate(`/sale/customers`);
          window.history.back();
        }
      } else {
        toast.error(data.error);
      }
    } catch (err) {
      toast.error("เพิ่มรายการไม่สำเร็จ!");
      console.error("Error creating customer:", err);
    }
  };

  function isBase64(str) {
    return (
      typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str)
    );
  }
  function base64ToBlob(base64, mimeType = "image/png") {
    const byteString = atob(base64.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ab], { type: mimeType });
  }

  return (
    <div className="h-[calc(100vh-64px)] bg-gray-50 flex flex-col overflow-y-auto w-full">
      <div className="max-w-5xl mx-auto w-full p-4 md:p-8 pb-20">
         <AppBreadcrumbs />
         <Toaster position="bottom-right" reverseOrder={false} />

         <div className="mt-6 bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
             {/* Header/Tabs */}
             <div className="border-b border-gray-100 bg-gray-50/50 p-1">
                <div className="flex p-1 bg-gray-200/50 rounded-xl w-max mx-auto md:mx-0 md:w-full md:max-w-md">
                   <button
                     onClick={() => handleTabChange(null, 0)}
                     className={`flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                       tabIndex === 0
                         ? "bg-white text-gray-800 shadow-sm"
                         : "text-gray-500 hover:text-gray-700 hover:bg-gray-200/50"
                     }`}
                   >
                     ข้อมูลส่วนตัว
                   </button>
                   <button
                     onClick={() => handleTabChange(null, 1)}
                     className={`flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                       tabIndex === 1
                         ? "bg-white text-gray-800 shadow-sm"
                         : "text-gray-500 hover:text-gray-700 hover:bg-gray-200/50"
                     }`}
                   >
                     การชำระเงิน
                   </button>
                </div>
             </div>

             <div className="p-6 md:p-8">
                {tabIndex === 0 && (
                   <div className="animate-fade-in">
                      <PersonalInfoForm
                        formData={formData}
                        handleChange={handleChange}
                        readCard={readCard}
                        customerGroups={customerGroups}
                        group={group}
                        setGroup={setGroup}
                        personType={personType}
                        setPersonType={setPersonType}
                        // ✅ ต่อกับ Dialog ใน PersonalInfoForm
                        cars={cars}
                        drivers={drivers}
                        handleAddCar={handleAddCar}
                        handleAddDriver={handleAddDriver}
                        handleDeleteCar={handleDeleteCar}
                        handleDeleteDriver={handleDeleteDriver}
                        handleCarChange={handleCarChange}
                        handleDriverChange={handleDriverChange}
                      />
                   </div>
                )}

                {tabIndex === 1 && (
                   <div className="animate-fade-in">
                      <PaymentInfoForm
                        formData={formData}
                        handleChange={handleChange}
                        readCard={readCard}
                        customerGroups={customerGroups}
                        group={group}
                        setGroup={setGroup}
                        personType={personType}
                        setPersonType={setPersonType}
                        cars={cars}
                        handleAddCar={handleAddCar}
                        handleDeleteCar={handleDeleteCar}
                        handleCarChange={handleCarChange}
                        handleDriverChange={handleDriverChange}
                        handleDriverChang={handleDriverChange}
                      />
                   </div>
                )}

                <div className="mt-8 pt-6 border-t border-gray-100 flex justify-center md:justify-end gap-3">
                   <button 
                      onClick={() => navigate(-1)}
                      className="px-6 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-medium hover:bg-gray-50 active:bg-gray-100 transition-colors"
                    >
                      ย้อนกลับ
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="px-8 py-2.5 rounded-xl bg-gradient-to-br from-[#10B981] to-[#059669] text-white font-medium shadow-lg shadow-green-200 hover:shadow-green-300 hover:translate-y-[-1px] active:translate-y-[0px] transition-all"
                    >
                      บันทึกข้อมูล
                    </button>
                </div>
             </div>
         </div>
      </div>
    </div>
  );
};

export default CustomerForm;
